import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config, ApiVisa } from "../../shared";
import { BranchDefaultSettlementMethodHdrContainerModel } from "../../../../../../models/aggregates/branch/branch-default-settlement-method-container.model";

@Injectable({
  providedIn: "root",
})
export class BranchDefaultSettlementMethodHdrService extends BaseApiTemplateService<BranchDefaultSettlementMethodHdrContainerModel> {
  constructor(http: HttpClient) {
    super();
    
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "branch-default-settlement-method-hdrs/" + 
      Core2Config.BACKOFFICE_EP_SUFFIX;
    
      this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "branch-default-settlement-method-hdrs/" + 
      Core2Config.BACKOFFICE_EP_SUFFIX;
    
      this.httpClient = http;
  }
}